(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-complete-look"] && !Shopify.designMode) return;
  try {
    class CompleteLook extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-complete-look-items]');

      if (!this.list || !this.dataset.url) return;
      this.load();
    }

    /* Complementary products are not part of the product page's own render — they only
       exist behind routes.product_recommendations_url, so the rows have to be fetched. An
       empty answer is the normal case (no complementary list for this product): leave the
       list empty and the block stays hidden by its own :has() rule. */
    async load() {
      let markup = '';

      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        markup = doc.querySelector('[data-complete-look-items]')?.innerHTML.trim() || '';
      } catch (error) {
        return;
      }

      if (!markup || !this.isConnected) return;

      /* Each row carries a <product-card>; the element upgrades itself on insertion and
         global.js runs its init() from the constructor, so nothing to wire up here.
         quick-cart-drawer.js binds its triggers through a MutationObserver on body. */
      this.list.innerHTML = markup;
    }
  }

  if (!customElements.get('complete-look')) {
    customElements.define('complete-look', CompleteLook);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-gifts"] && !Shopify.designMode) return;
  try {
    // Query flag on cart-gifts' own cart requests, so its request watcher can tell them apart.
  const CART_GIFTS_MARKER = 'cart-gifts=1';

  class CartGifts extends HTMLElement {
    connectedCallback() {
      const rate = Number(window.Shopify?.currency?.rate) || 1;

      // Thresholds are entered in the store currency — convert them like the shipping bar does.
      this.gifts = [...this.querySelectorAll('[data-gift-tier]')].map((tier, index) => ({
        tier,
        card: this.querySelector(`[data-gift-card="${index}"]`),
        threshold: Math.round(Number(tier.dataset.threshold) * rate),
        productId: Number(tier.dataset.productId),
        variantIds: tier.dataset.variantIds.split(',').filter(Boolean).map(Number),
        defaultVariantId: Number(tier.dataset.defaultVariantId)
      }));
      if (!this.gifts.length) return;

      // Swatches are on the gift card and on the gift's line in the cart items, both inside the drawer.
      // Set before restoreSwatch, which looks them up through it.
      this.drawer = this.closest('cart-drawer') || this;

      this.fill = this.querySelector('.cart-gifts__fill');
      this.gifts.forEach((gift) => {
        gift.tier.querySelector('[data-gift-over]').textContent = this.dataset.textOver.replace(
          '[amount]',
          this.formatMoney(gift.threshold)
        );
        this.restoreSwatch(gift);
      });

      this.drawer.addEventListener('click', this.onSwatchClick);
      this.render(Number(this.dataset.cartTotal) || 0);
      this.moveGiftItemsFirst();
      this.addItemSwatches();
      this.unlinkGiftItems();

      // The drawer re-renders #CartDrawer-Body after every cart change (add, quantity, remove).
      this.cartBody = this.closest('cart-drawer')?.querySelector('#CartDrawer-Body');
      if (this.cartBody) {
        this.observer = new MutationObserver(this.onCartRender);
        this.observer.observe(this.cartBody, { childList: true });
      }

      this.watchCartRequests();
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.requestObserver?.disconnect();
      clearTimeout(this.syncTimer);
      this.drawer?.removeEventListener('click', this.onSwatchClick);
    }

    // Runs as a microtask right after the new HTML is in, before paint — no link flashes.
    onCartRender = () => {
      this.moveGiftItemsFirst();
      this.addItemSwatches();
      this.unlinkGiftItems();
      // Our own update just rendered this — the cart is already the way sync left it.
      if (this.isOwnRender) {
        this.isOwnRender = false;
        return;
      }
      this.scheduleSync();
    };

    // Shopify fires no event when the cart changes, and the theme's 'cart-update' pubsub event only
    // comes from some of its forms — not from quick add, apps or a plain fetch. So every finished
    // request to /cart/add|change|update|clear is watched instead (Resource Timing: nothing is
    // wrapped or patched), whoever sent it, and the cart is checked again after it. Our own
    // requests carry CART_GIFTS_MARKER and are skipped, so sync never answers itself.
    watchCartRequests() {
      if (!('PerformanceObserver' in window)) return;

      this.requestObserver = new PerformanceObserver((list) => {
        const isCartChange = list
          .getEntries()
          .some(({ name }) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(name) && !name.includes(CART_GIFTS_MARKER));
        if (isCartChange) this.scheduleSync();
      });

      try {
        this.requestObserver.observe({ type: 'resource' });
      } catch (error) {
        this.requestObserver = null;
      }
    }

    // A cart change usually arrives twice (its request, then the drawer render) — one sync for both.
    scheduleSync() {
      clearTimeout(this.syncTimer);
      this.syncTimer = setTimeout(() => this.sync(), 100);
    }

    // The gift heads the drawer's item list. Shopify puts every new line on top, so anything added
    // after the gift pushes it down. The line is moved, not reordered with CSS `order`: the
    // separators between items come from `.cart-item + .cart-item`, which follows the markup. Its
    // data-index (the line's place in the Shopify cart) stays as it is.
    moveGiftItemsFirst() {
      const list = this.drawer.querySelector('.cart-drawer__items');
      if (!list) return;

      const giftItems = this.gifts.flatMap(({ productId }) => [
        ...list.querySelectorAll(`:scope > .cart-item[data-product-id="${productId}"]`)
      ]);
      list.prepend(...giftItems);
    }

    // Gives the gift's cart line in the drawer its swatches, copied from the templates. Runs before
    // unlinkGiftItems: the selected color is read from the line's product link (?variant=).
    addItemSwatches() {
      this.gifts.forEach((gift) => {
        const template = this.querySelector(`template[data-gift-swatches-template="${gift.productId}"]`);
        const swatches = template?.content.firstElementChild;
        if (!swatches) return;

        this.drawer.querySelectorAll(`.cart-item[data-product-id="${gift.productId}"]`).forEach((item) => {
          const content = item.querySelector('.cart-item__content');
          if (!content || content.querySelector('[data-gift-swatches]')) return;

          const link = item.querySelector('a[href*="variant="]');
          const variantId = link ? Number(new URL(link.href, window.location.origin).searchParams.get('variant')) : 0;
          const itemSwatches = swatches.cloneNode(true);
          itemSwatches.querySelectorAll('.cart-gifts__swatch').forEach((swatch) => {
            swatch.setAttribute('aria-checked', String(Number(swatch.dataset.variantId) === variantId));
          });

          const bottom = content.querySelector('.cart-item__bottom-content');
          if (bottom) {
            bottom.before(itemSwatches);
          } else {
            content.append(itemSwatches);
          }
        });
      });
    }

    // A gift is not a product to browse: its title and image lose the product link and keep
    // their content. Covers the drawer and the /cart page, which re-renders with the drawer.
    unlinkGiftItems() {
      this.gifts.forEach(({ productId }) => {
        document
          .querySelectorAll(
            `.cart-item[data-product-id="${productId}"] :is(.cart-item__title a, a.cart-item__link)`
          )
          .forEach((link) => link.replaceWith(...link.childNodes));
      });
    }

    onSwatchClick = (event) => {
      const swatch = event.target.closest('[data-gift-swatches] .cart-gifts__swatch');
      if (!swatch || swatch.disabled) return;

      const productId = Number(swatch.closest('[data-gift-swatches]').dataset.giftSwatches);
      const gift = this.gifts.find((gift) => gift.productId === productId);
      if (!gift) return;

      const variantId = Number(swatch.dataset.variantId);
      gift.chosenVariantId = variantId;
      this.selectSwatch(gift, variantId);
      try {
        localStorage.setItem(`cart-gifts:${gift.productId}`, variantId);
      } catch (error) {
        // Storage unavailable (private mode) — the choice just isn't remembered.
      }

      // The gift is already in the cart — sync swaps it for the picked color. The swatches wait
      // for it: the cart re-render brings fresh ones, and sync enables any that are left.
      if (gift === this.getUnlockedGift(this.total)) {
        this.getSwatches(gift).forEach((button) => (button.disabled = true));
        this.sync();
      }
    };

    // Every swatch of this gift: on its card and on its cart line.
    getSwatches(gift) {
      return this.drawer.querySelectorAll(`[data-gift-swatches="${gift.productId}"] .cart-gifts__swatch`);
    }

    selectSwatch(gift, variantId) {
      this.getSwatches(gift).forEach((swatch) => {
        swatch.setAttribute('aria-checked', String(Number(swatch.dataset.variantId) === variantId));
      });
      gift.card?.querySelectorAll('[data-gift-image]').forEach((image) => {
        image.hidden = Number(image.dataset.giftImage) !== variantId;
      });
    }

    restoreSwatch(gift) {
      const variantId = this.getChosenVariantId(gift);
      if (variantId !== gift.defaultVariantId) this.selectSwatch(gift, variantId);
    }

    // The swatch the customer picked for this gift, if it is still available.
    getChosenVariantId(gift, fallbackVariantId = gift.defaultVariantId) {
      let chosen = gift.chosenVariantId || null;
      if (!chosen) {
        try {
          chosen = Number(localStorage.getItem(`cart-gifts:${gift.productId}`));
        } catch (error) {
          chosen = null;
        }
      }
      return gift.variantIds.includes(chosen) ? chosen : fallbackVariantId;
    }

    render(total) {
      const pendingGift = this.gifts.find((gift) => total < gift.threshold);
      // Every total reached: the top gift's card stays, marked as added.
      const cardGift = pendingGift || this.gifts[this.gifts.length - 1];

      this.total = total;
      this.fill.style.width = `${this.getProgress(total)}%`;
      this.gifts.forEach((gift) => {
        const isReached = total >= gift.threshold;
        gift.tier.classList.toggle('is-reached', isReached);
        this.renderStatus(gift.tier.querySelector('[data-gift-status]'), isReached, gift.threshold - total);
        if (gift.card) {
          gift.card.hidden = gift !== cardGift;
          gift.card.classList.toggle('is-added', gift === cardGift && !pendingGift);
        }
      });
    }

    // "$36 to Unlock": the amount is highlighted, as in the design.
    renderStatus(status, isReached, remaining) {
      if (isReached) {
        status.textContent = this.dataset.textUnlocked;
        return;
      }
      const [before, after = ''] = this.dataset.textToUnlock.split('[amount]');
      const amount = document.createElement('span');
      amount.className = 'cart-gifts__amount';
      amount.textContent = this.formatMoney(remaining);
      status.replaceChildren(before, amount, after);
    }

    // Each gift's badge sits in the middle of its column; the fill runs from badge to badge.
    getProgress(total) {
      const count = this.gifts.length;
      let previousThreshold = 0;
      let previousPosition = 0;

      for (let index = 0; index < count; index++) {
        const { threshold } = this.gifts[index];
        const position = ((index + 0.5) / count) * 100;
        if (total < threshold) {
          const segment = Math.max(total - previousThreshold, 0) / (threshold - previousThreshold);
          return previousPosition + segment * (position - previousPosition);
        }
        previousThreshold = threshold;
        previousPosition = position;
      }
      return 100;
    }

    getUnlockedGift(total) {
      return [...this.gifts].reverse().find((gift) => total >= gift.threshold) || null;
    }

    // Keeps exactly one gift in the cart: the one for the highest reached total, or none.
    async sync() {
      if (this.isSyncing) {
        this.needsSync = true;
        return;
      }
      this.isSyncing = true;

      try {
        const cart = await fetch(`${window.routes.cart_url}.js`).then((response) => response.json());
        const giftProductIds = this.gifts.map((gift) => gift.productId);
        const giftItems = cart.items.filter((item) => giftProductIds.includes(item.product_id));
        const giftsTotal = giftItems.reduce((sum, item) => sum + item.final_line_price, 0);
        const total = cart.total_price - giftsTotal;
        const unlockedGift = this.getUnlockedGift(total);
        const unlockedItems = giftItems.filter((item) => item.product_id === unlockedGift?.productId);

        this.render(total);

        const cartVariantId = unlockedItems[0]?.variant_id || unlockedGift?.defaultVariantId;
        const chosenVariantId = unlockedGift ? this.getChosenVariantId(unlockedGift, cartVariantId) : null;
        if (unlockedGift) this.selectSwatch(unlockedGift, chosenVariantId);

        let updates = this.getGiftUpdates(giftItems, unlockedGift, chosenVariantId);
        const isUpdated = !Object.keys(updates).length || (await this.updateCart(updates));

        if (!isUpdated) {
          if (unlockedItems.length) {
            // e.g. the picked color sold out — keep the color that is already in the cart, still
            // trimmed to one piece, and show that one.
            unlockedGift.chosenVariantId = unlockedItems[0].variant_id;
            this.selectSwatch(unlockedGift, unlockedGift.chosenVariantId);
            updates = this.getGiftUpdates(giftItems, unlockedGift, unlockedGift.chosenVariantId);
          } else {
            // The gift could not be added (e.g. it just sold out) — the other gifts still go.
            updates = Object.fromEntries(Object.entries(updates).filter(([, quantity]) => quantity === 0));
          }
          if (Object.keys(updates).length) await this.updateCart(updates);
        }
      } catch (error) {
        console.error('cart-gifts:', error);
      } finally {
        this.isSyncing = false;
        this.drawer.querySelectorAll('[data-gift-swatches] .cart-gifts__swatch:disabled').forEach((button) => {
          button.disabled = false;
        });
        if (this.needsSync) {
          this.needsSync = false;
          this.sync();
        }
      }
    }

    // Line updates that leave at most one gift in the cart: one piece of the unlocked gift in the
    // chosen color, nothing else. Keyed by line item key, not variant ID — the same variant on two
    // lines (e.g. one with properties) is two lines, and a variant ID only ever reaches one of them.
    getGiftUpdates(giftItems, unlockedGift, chosenVariantId) {
      const updates = {};
      const keptItem = unlockedGift
        ? giftItems.find((item) => item.product_id === unlockedGift.productId && item.variant_id === chosenVariantId)
        : null;

      giftItems.forEach((item) => {
        if (item === keptItem) {
          if (item.quantity !== 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });

      // Not in the cart yet: a variant ID adds it.
      if (unlockedGift && !keptItem) updates[chosenVariantId] = 1;

      return updates;
    }

    async updateCart(updates) {
      const cartDrawer = this.closest('cart-drawer');
      const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.section) || [];

      const response = await fetch(`${window.routes.cart_update_url}.js?${CART_GIFTS_MARKER}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
      });
      // e.g. the gift sold out — leave the cart as it is instead of retrying in a loop.
      if (!response.ok) return false;

      const state = await response.json();
      if (state.sections && typeof cartDrawer?.renderContents === 'function') {
        this.isOwnRender = true;
        cartDrawer.renderContents(state, false);
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      } else {
        // No drawer script on this page (e.g. the cart page) — reload to show the updated cart.
        window.location.reload();
      }
      return true;
    }

    // "$100.00" → "$100", as in the design; non-round amounts keep their cents.
    formatMoney(cents) {
      const moneyFormat = window.theme?.settings?.money_format;
      const money =
        typeof formatPrice === 'function' && moneyFormat ? formatPrice(cents, moneyFormat) : (cents / 100).toFixed(2);
      return money.replace(/[.,]00(?=\D*$)/, '');
    }
  }

  if (!customElements.get('cart-gifts')) {
    customElements.define('cart-gifts', CartGifts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.cart-upsell__slider');
      this.track = this.querySelector('[data-cart-upsell-items]');
      this.pagination = this.querySelector('.cart-upsell__pagination');

      if (!this.track) return;

      /* No data-url means the cards are already on the page: the merchant picked them by hand,
         or there is no line item to base a recommendation on. Either way, nothing to fetch. */
      if (this.dataset.url) {
        this.load();
        return;
      }

      this.initSlider();
    }

    disconnectedCallback() {
      /* The cart drawer replaces its whole body on every quantity change, so this element is
         thrown away and rebuilt often — leaving Swiper's listeners behind would pile them up. */
      window.removeEventListener('resize', this.onResize);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    onResize = () => {
      this.swiper?.update();
    };

    /* Complementary products are not part of the cart's own render — they only exist behind
       routes.product_recommendations_url, so the cards have to be fetched. An empty answer is
       the normal case (no complementary list for this product): leave the track empty and the
       block stays hidden by its own :has() rule. */
    async load() {
      let markup = '';

      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        markup = doc.querySelector('[data-cart-upsell-items]')?.innerHTML.trim() || '';
      } catch (error) {
        return;
      }

      if (!markup || !this.isConnected) return;

      /* Each card carries a <product-card>; the element upgrades itself on insertion and
         global.js runs its init() from the constructor, so nothing to wire up here.
         quick-cart-drawer.js binds its triggers through a MutationObserver on body. */
      this.track.innerHTML = markup;
      this.initSlider();
    }

    /* Two cards are in view on mobile, three from 750px; when they all fit, watchOverflow leaves
       Swiper disabled and the row simply sits there — the slider only comes alive past that.
       Built here rather than through <swiper-component>, which initialises once on its own
       schedule and would land on an empty track: the same reason assets/product-recommendations.js
       constructs its Swiper by hand. */
    async initSlider() {
      if (this.swiper || !this.slider) return;
      if (!this.track.children.length) return;

      /* Read while .swiper-initialized is still absent, so the stylesheet's column-gap is live
         and resolves to px — no spacing value is duplicated in JS. */
      const gap = parseFloat(getComputedStyle(this.track).columnGap);

      await this.whenSwiperReady();
      if (typeof window.Swiper === 'undefined' || this.swiper || !this.isConnected) return;

      this.swiper = new Swiper(this.slider, {
        /* Two across on mobile, three from 750px — the same split as the card width in the
           stylesheet, so nothing shifts when Swiper takes over. */
        slidesPerView: 2,
        breakpoints: {
          991: { slidesPerView: 3 }
        },
        spaceBetween: Number.isNaN(gap) ? 0 : gap,
        watchOverflow: true,
        grabCursor: true,
        /* The same bullet markup as <swiper-component>'s custom bullets in global.js, which the
           theme's .swiper-pagination--dots styles are written for. */
        pagination: this.pagination
          ? {
              el: this.pagination,
              clickable: true,
              renderBullet: (index, className) => `<button type="button" class="${className}"><span></span></button>`
            }
          : false,
        /* Swiper's ResizeObserver watches its own element. Every card holds a square,
           aspect-ratio media, so each recalculation changes that element's size, which fires the
           observer, which recalculates again — the block inflates pass after pass and never
           settles. The viewport is the only resize that actually matters here, and it is handled
           by onResize above. */
        resizeObserver: false
      });

      window.addEventListener('resize', this.onResize);
    }

    /* Swiper is a deferred global script, and this file is part of the theme's bundled JS —
       nothing guarantees the bundle runs after it. Resolve defensively rather than assume the
       order, the same way sections/section-ugc-videos.liquid does. */
    whenSwiperReady() {
      if (typeof window.Swiper !== 'undefined') return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (typeof window.Swiper !== 'undefined' || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }
  }

  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', CartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facet-number-range"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('facet-number-range')) {
    class FacetNumberRange extends HTMLElement {
      // The horizontal bar and the drawer copy of the same filter can both sit in the DOM
      // with their own leftover field values from earlier in the session (the untouched one
      // never gets cleared just because the other was edited). Without tracking which one was
      // actually typed into last, resolveActiveRange()/syncFields() would deterministically
      // prefer whichever copy happens to come first in document order — on this theme that is
      // always the horizontal bar, so anything typed into the drawer would be silently
      // shadowed by whatever the horizontal bar last held, no matter how recent. Keyed by
      // paramName since separate filters (carat weight, size, ...) must not shadow each other.
      static lastActive = new Map();

      connectedCallback() {
        this.minField = this.querySelector('[data-number-range-min]');
        this.maxField = this.querySelector('[data-number-range-max]');
        this.list = this.closest('.js-filter')?.querySelector('.facets__list');
        this.paramName = this.dataset.paramName;
        this.filterLabel = this.dataset.filterLabel;

        if (!this.minField || !this.maxField || !this.list) return;

        // 'input', not 'change': change only fires on blur, and closing the filter drawer
        // (tapping its own close control, or a backdrop) does not reliably blur a focused
        // field first on every mobile browser, so a value typed right before closing could
        // never get applied. The theme's own price-range fields already use 'input' for the
        // same reason (assets/facets.js's validateInput wiring).
        this.minField.addEventListener('input', this.onChange);
        this.maxField.addEventListener('input', this.onChange);
        this.addEventListener('keydown', this.onKeyDown);

        // facets.js replaces .active-facets wholesale on every request (renderActiveFacets),
        // and Shopify never reports the emptyMarker checkbox back as an active value since it
        // is not a real option — so the "no matches" chip has nothing server-rendered to
        // survive on. Re-built here every time facets.js says a request just landed, instead
        // of watching the DOM for changes — a MutationObserver on .active-facets also sees the
        // chip's own insertion as a change and re-fires on itself, which is harmless in the end
        // but makes the whole thing harder to reason about than an explicit signal.
        //
        // The same event is also this filter's other copy's (horizontal bar vs "More filters"
        // drawer) only way to learn a request happened at all: a hidden copy is never destroyed
        // and reconnected with fresh server values the way the interacted copy's *sibling
        // filters* are (see facets.js's renderFilters), so without this it would still be
        // showing blank fields days later.
        this.activeFacets = document.querySelector('.active-facets');
        this.onActiveFacetsRendered = () => {
          this.syncChip();
          this.syncFields();
        };
        document.addEventListener('facets:active-facets-rendered', this.onActiveFacetsRendered);
        this.syncChip();
        this.syncFields();
      }

      disconnectedCallback() {
        this.minField?.removeEventListener('input', this.onChange);
        this.maxField?.removeEventListener('input', this.onChange);
        this.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('facets:active-facets-rendered', this.onActiveFacetsRendered);
      }

      // Enter would submit the surrounding form with the checkboxes still untouched
      onKeyDown = event => {
        if (event.key !== 'Enter') return;

        event.preventDefault();
        event.target.blur();
      };

      onChange = () => this.apply();

      get items() {
        return Array.from(this.list.querySelectorAll('input[type="checkbox"]:not([data-number-range-empty])'))
          .map(input => ({ input, number: Number(input.value) }))
          .filter(item => !Number.isNaN(item.number));
      }

      // An empty checked set is not "match nothing" to Shopify, it is "no filter applied" —
      // dropping the param brings every product back. There is no value a shopper could type
      // that this list is guaranteed not to contain, so when the range matches zero of the
      // existing checkboxes, a synthetic checkbox with a value no real product can have is
      // checked instead, so the request still comes back with zero results.
      get emptyMarker() {
        if (this._emptyMarker) return this._emptyMarker;

        const template = this.list.querySelector('input[type="checkbox"]');
        if (!template) return null;

        const marker = document.createElement('input');
        marker.type = 'checkbox';
        marker.name = this.paramName || template.name;
        marker.value = '__facet-number-range-no-match__';
        marker.hidden = true;
        marker.setAttribute('data-number-range-empty', '');
        this.list.appendChild(marker);

        this._emptyMarker = marker;
        return marker;
      }

      // The state of ONE pair of fields, read straight off a specific instance — used both as
      // the fast path (the instance last typed into, see apply()) and as one candidate in the
      // page-load fallback scan below. Shown as literally what was typed, not the real value(s)
      // it matched or whether it matched anything: with values of 0.1/0.2/0.3 on the shelf,
      // typing 0.1-0.5 only matches 0.1, but a chip built from that match would misleadingly
      // read "0.1 - 0.1" — and typing 0.2-0.2 against the same shelf matches nothing at all,
      // which is exactly why this chip cannot be server-rendered the way every other one in
      // snippets/facets.liquid is: active_values only ever lists real matched values, never
      // the range itself, so there would be nothing to build a chip from there in either case.
      readRangeFrom(element) {
        const from = element.minField?.value;
        const to = element.maxField?.value;
        if (!from && !to) return null;

        return {
          from: from || element.minField.placeholder,
          to: to || element.maxField.placeholder,
        };
      }

      // The horizontal bar and the drawer each render their own copy of this filter, and a
      // copy that was never touched this session can still be sitting on a leftover value from
      // much earlier — typing 0.1-0.3 into the drawer must not lose to the horizontal bar
      // still holding 0.1-0.1 from an unrelated interaction. So once any instance has actually
      // had apply() called on it, that one instance is the sole source of truth; every copy is
      // only scanned before that has ever happened — a fresh page load where the URL already
      // carries an active filter, and no instance has been typed into this session yet.
      resolveActiveRange() {
        const recent = FacetNumberRange.lastActive.get(this.paramName);
        if (recent?.isConnected) return this.readRangeFrom(recent);

        for (const element of document.querySelectorAll(
          `facet-number-range[data-param-name="${CSS.escape(this.paramName)}"]`
        )) {
          const state = this.readRangeFrom(element);
          if (state) return state;
        }

        return null;
      }

      // Mirrors whichever copy of this filter was actually typed into onto this one, so a
      // drawer instance opened after the horizontal bar was used (or vice versa) shows what's
      // really applied instead of blank fields. Only pulls when this instance is itself blank
      // — never overwrites values the shopper is actively typing into this copy.
      syncFields() {
        if (this.minField.value || this.maxField.value) return;

        const recent = FacetNumberRange.lastActive.get(this.paramName);
        const source = recent?.isConnected && recent !== this && (recent.minField?.value || recent.maxField?.value)
          ? recent
          : Array.from(
              document.querySelectorAll(`facet-number-range[data-param-name="${CSS.escape(this.paramName)}"]`)
            ).find(element => element !== this && (element.minField?.value || element.maxField?.value));

        if (!source) return;

        this.minField.value = source.minField.value;
        this.maxField.value = source.maxField.value;
      }

      // Cannot be server-rendered — see readRangeFrom() — so built and kept in sync from here
      // entirely; see the facets:active-facets-rendered listener set up in connectedCallback.
      syncChip() {
        if (!this.activeFacets || !this.paramName) return;

        const selector = `[data-number-range-chip="${CSS.escape(this.paramName)}"]`;
        const existing = this.activeFacets.querySelector(selector);
        const state = this.resolveActiveRange();

        if (!state) {
          existing?.remove();
          return;
        }

        const text = `${this.filterLabel}: ${state.from} - ${state.to}`;

        if (existing) {
          const label = existing.querySelector('span');
          if (label) label.textContent = text;
          return;
        }

        const chip = document.createElement('div');
        chip.className = 'active-facets__button';
        chip.setAttribute('data-number-range-chip', this.paramName);

        const textEl = document.createElement('div');
        textEl.className = 'active-facets__button-text';
        const label = document.createElement('span');
        label.textContent = text;
        textEl.appendChild(label);

        // Not wrapped in <facet-remove>: that custom element's constructor requires an <a>
        // child and removes filters by navigating to filter.url_to_remove — neither applies
        // here, since Shopify never resolves a URL for a value it does not recognize.
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'active-facets__button-link button-reset';
        button.addEventListener('click', () => this.clearAll());

        const iconTemplate = this.querySelector('[data-number-range-close-icon]');
        if (iconTemplate) button.appendChild(iconTemplate.content.cloneNode(true));

        chip.append(textEl, button);
        this.activeFacets.appendChild(chip);
      }

      // Resets every copy of this filter (horizontal bar + drawer), not just this instance.
      //
      // Deliberately not "clear the fields and call apply()": with the fields blank, apply()
      // treats -Infinity..Infinity as matching every real checkbox and checks them all — which
      // is the field-blur behaviour, not "remove the filter". Checking every real value is not
      // the same request as no filter at all: a product with no value for this metafield would
      // match "not filtered" but not "carat_weight2 is one of 0.1, 0.2, 0.3, 0.5", so clicking
      // the chip's × would visibly fail to bring it back. Explicitly unchecking everything (the
      // marker included) is the only request that actually means no filter.
      clearAll() {
        // Removed immediately rather than waiting on the debounced submit to come back and
        // trigger syncChip() — the shopper clicked to clear the filter, it should look cleared
        // right away.
        this.activeFacets
          ?.querySelector(`[data-number-range-chip="${CSS.escape(this.paramName)}"]`)
          ?.remove();

        document.querySelectorAll(`facet-number-range[data-param-name="${CSS.escape(this.paramName)}"]`).forEach(element => {
          if (!element.minField || !element.maxField || !element.list) return;

          element.minField.value = '';
          element.maxField.value = '';

          const checkboxes = Array.from(element.list.querySelectorAll('input[type="checkbox"]'));
          const wasChecked = checkboxes.some(input => input.checked);
          checkboxes.forEach(input => {
            input.checked = false;
          });

          if (wasChecked) checkboxes[0].dispatchEvent(new Event('input', { bubbles: true }));
        });
      }

      apply() {
        const items = this.items;
        if (!items.length) return;

        // This instance now holds the authoritative from/to for this filter — see
        // resolveActiveRange()/syncFields().
        FacetNumberRange.lastActive.set(this.paramName, this);

        const from = this.read(this.minField, -Infinity);
        const to = this.read(this.maxField, Infinity);

        const matched = items.filter(item => item.number >= from && item.number <= to);

        // What the shopper typed is left alone. An earlier version snapped the bounds to
        // the nearest available value and wrote that back, which meant typing 0.5 against
        // values of 0.25 and 1.5 turned the field into 1.5 — the price filter does not do
        // that either.
        items.forEach(item => {
          item.input.checked = matched.includes(item);
        });

        const marker = this.emptyMarker;
        if (marker) marker.checked = matched.length === 0;

        this.syncChip();

        // facets.js listens for `input` on #FacetFiltersForm and submits debounced, so one
        // bubbling event is all it takes — no need to reach for the form itself. Dispatched
        // from a checkbox rather than from the list: shouldPreventSubmit() reads
        // `event.target.form`, and while it tolerates that being undefined today, an input
        // is what it expects. Any checkbox will do — they are all in the document whether
        // the range matched them or not.
        items[0].input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      read(field, fallback) {
        const value = parseFloat(field.value);

        return Number.isNaN(value) ? fallback : value;
      }
    }

    customElements.define('facet-number-range', FacetNumberRange);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product__accordion_block"] && !Shopify.designMode) return;
  try {
    (() => {
    class ProductAccordion extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('[data-accordion-panel]');
        this.content = this.querySelector('.product-accordion__content');

        if (!this.details || !this.summary || !this.panel) return;

        this.animation = null;
        this.summary.addEventListener('click', this.onClick);

        // The theme already fetches the whole section on every variant change and
        // hands the parsed document to every subscriber, so refreshing costs no extra
        // request. The event name is a literal rather than PUB_SUB_EVENTS.variantChange
        // so this does not depend on global.js having run first.
        if (this.hasAttribute('data-variant-triggered') && typeof subscribe === 'function') {
          this.unsubscribe = subscribe('variant-change', this.onVariantChange);
        }
      }

      disconnectedCallback() {
        if (this.summary) this.summary.removeEventListener('click', this.onClick);
        if (this.animation) this.animation.cancel();
        if (this.unsubscribe) this.unsubscribe();
      }

      // Only the inner content is replaced, so the open/closed state and any running
      // animation on <details> survive.
      onVariantChange = (event) => {
        const html = event && event.data && event.data.html;
        if (!html || !this.content || !this.content.id) return;

        // The block is not rendered at all when a variant has no content, so an absent
        // copy means "nothing to show" rather than "nothing changed" — without this the
        // previous variant's text would stay on screen.
        const fresh = html.getElementById(this.content.id);
        if (!fresh) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.content.innerHTML = fresh.innerHTML;

        // new content means a new natural height; an inline one left over from an
        // interrupted animation would clip it
        if (!this.animation) this.panel.style.height = '';
      };

      // The native toggle would snap open, so it is taken over here. Everything the
      // browser gives us — keyboard, roles, the open attribute — is left in place.
      onClick = (event) => {
        event.preventDefault();

        if (this.details.open) this.collapse();
        else this.expand();
      };

      get duration() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
      }

      // Height of the panel as it is painted right now, so interrupting an
      // animation reverses from where it stands instead of jumping.
      get currentHeight() {
        return this.animation ? this.panel.getBoundingClientRect().height : 0;
      }

      expand() {
        const from = this.currentHeight;

        if (this.animation) this.animation.cancel();

        // has to be open before measuring: <details> does not render the panel while closed
        this.details.open = true;
        this.run(from, this.panel.scrollHeight);
      }

      collapse() {
        const from = this.animation ? this.currentHeight : this.panel.scrollHeight;

        if (this.animation) this.animation.cancel();

        this.run(from, 0, () => {
          this.details.open = false;
        });
      }

      run(from, to, onFinish) {
        this.animation = this.panel.animate(
          { height: [from + 'px', to + 'px'] },
          { duration: this.duration, easing: 'ease' }
        );

        this.animation.onfinish = () => {
          this.animation = null;
          this.panel.style.height = '';
          if (onFinish) onFinish();
        };
      }
    }

    if (!customElements.get('product-accordion')) {
      customElements.define('product-accordion', ProductAccordion);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product__media-gallery"] && !Shopify.designMode) return;
  try {
    /* Pins the media column and plays the gallery through it as the page scrolls.

     The travel is 1:1 with the page: the column keeps the gallery's full natural height,
     the visible box is shorter, and the strip is moved up by exactly the distance the
     sticky box has been pinned. So the page cannot get past the product until the whole
     gallery has passed — without touching the scroll itself. No wheel or touch handler,
     no preventDefault: keyboard, trackpad inertia and find-in-page all keep working. */
  class ProductGalleryScroll extends HTMLElement {
    connectedCallback() {
      this.strip = document.getElementById(this.dataset.gallery);
      this.column = this.strip?.closest('.product-grid__item--media');
      this.viewport = this.strip?.closest('.product-grid__item--media-wrapper');
      this.content = document.querySelector('.product-grid__item--content');

      if (!this.strip || !this.column || !this.viewport || !this.content) return;

      /* Same breakpoint the theme uses everywhere, and the same escape hatch: below it,
         or when the visitor asked for less motion, the gallery stays a plain long column. */
      this.desktop = window.matchMedia('screen and (min-width: 750px)');
      this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onScroll = this.onScroll.bind(this);
      this.onChange = this.onChange.bind(this);

      this.observer = new ResizeObserver(() => this.measure());
      this.desktop.addEventListener('change', this.onChange);
      this.calm.addEventListener('change', this.onChange);

      this.onChange();
    }

    disconnectedCallback() {
      this.stop();
      this.desktop?.removeEventListener('change', this.onChange);
      this.calm?.removeEventListener('change', this.onChange);
    }

    get active() {
      return this.desktop.matches && !this.calm.matches;
    }

    onChange() {
      if (this.active) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (this.running) return;
      this.running = true;

      this.column.setAttribute('data-gallery-pinned', '');
      this.observer.observe(this.strip);
      this.observer.observe(this.content);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.measure();
    }

    stop() {
      if (!this.running) return;
      this.running = false;

      this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);

      this.column.removeAttribute('data-gallery-pinned');
      this.column.style.removeProperty('--pdp-gallery-viewport');
      this.column.style.removeProperty('--pdp-gallery-track');
      this.strip.style.removeProperty('transform');
      this.travel = 0;
    }

    measure() {
      if (!this.running) return;

      /* The box matches the info column, floored at the setting's minimum and capped at
         what actually fits on screen — a pinned box taller than the viewport could never
         show its lower half. */
      const min = Number(this.dataset.minHeight) || 700;

      /* The cap is read from the sticky offset in CSS, not from the box's current position:
         getBoundingClientRect().top moves with the scroll, so measuring from it made the
         cap grow the further down the page the visitor was. */
      const offset = parseFloat(getComputedStyle(this.viewport).insetBlockStart) || 0;
      const fits = window.innerHeight - offset - 24;
      const box = Math.max(min, Math.min(this.content.offsetHeight, Math.max(fits, min)));

      /* scrollHeight, not offsetHeight: the box already clips the strip, so its laid-out
         height is the box height and only the scroll height still knows the real one. */
      const strip = Math.max(this.viewport.scrollHeight, box);

      this.travel = strip - box;

      /* The column keeps the gallery's full height so the page has that much left to
         scroll; the box inside it is what the visitor sees. */
      this.column.style.setProperty('--pdp-gallery-viewport', `${box}px`);
      this.column.style.setProperty('--pdp-gallery-track', `${strip}px`);

      this.onScroll();
    }

    onScroll() {
      if (this.frame) return;

      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (!this.running) return;

        /* How far the sticky box has already been pinned inside its column — 0 before it
           catches, growing to the travel once it lets go. Measured as the gap between the
           two boxes so the sticky offset itself never has to be parsed out of CSS. */
        const pinned = this.viewport.getBoundingClientRect().top - this.column.getBoundingClientRect().top;
        const moved = Math.min(Math.max(pinned, 0), this.travel);

        this.strip.style.transform = moved > 0 ? `translate3d(0, ${-moved}px, 0)` : '';
      });
    }
  }

  if (!customElements.get('product-gallery-scroll')) {
    customElements.define('product-gallery-scroll', ProductGalleryScroll);
  }

  /* PhotoSwipe fallback.

     assets/product-media-gallery.js only ever starts PhotoSwipe from setInteractions(),
     which its init() reaches after this guard:

       if (this.offsetWidth === 0 && this.offsetHeight === 0 && !this.checkVisibility()) return;

     In the "Grid" desktop gallery layout the slider that carries the `zoom` attribute is
     .main-product__media--slider-wrapper.small-up-hide — display:none above 750px. It has
     no dimensions, so it returns early, PhotoSwipe is never constructed, and every
     .product__gallery-toggle falls through to its plain href (the image opens in a new
     tab). The grid's own <swiper-product-gallery> elements carry no `zoom` attribute, so
     they never start it either. Same story for a one-image product, which has no slider
     at all.

     This binds the gallery only when that vendor path cannot: the test is the very same
     visibility predicate, so exactly one of the two ever runs and no anchor is bound
     twice. Config mirrors photoSwipeLightboxInit() so both paths behave identically. */
  class ProductGalleryZoom extends HTMLElement {
    connectedCallback() {
      this.boot = this.boot.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.boot, { once: true });
      } else {
        this.boot();
      }
    }

    disconnectedCallback() {
      this.lightbox?.destroy();
      this.lightbox = null;
    }

    /* The vendor's own test, applied to the element it tests. */
    vendorWillBind() {
      return Array.from(document.querySelectorAll('swiper-product-gallery[zoom]')).some(
        (el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length
      );
    }

    async boot() {
      if (this.lightbox || this.vendorWillBind()) return;
      if (!document.querySelector('.photoswipe-wrapper a.product__gallery-toggle')) return;

      await this.whenLibsReady();
      if (!this.isConnected || this.lightbox || this.vendorWillBind()) return;
      if (typeof window.PhotoSwipeLightbox === 'undefined') return;

      this.start();
    }

    /* photoswipe*.js are deferred globals; resolve defensively rather than assume order. */
    whenLibsReady() {
      const ready = () =>
        typeof window.PhotoSwipeLightbox !== 'undefined' && typeof window.PhotoSwipe !== 'undefined';
      if (ready()) return Promise.resolve();

      return new Promise((resolve) => {
        const start = performance.now();
        const poll = () => {
          if (ready() || performance.now() - start > 5000) {
            resolve();
            return;
          }
          requestAnimationFrame(poll);
        };
        poll();
      });
    }

    start() {
      const closeIcon = document.querySelector('[data-close-icon]');
      const prevIcon = document.querySelector('[data-prev-icon]');
      const nextIcon = document.querySelector('[data-next-icon]');

      this.lightbox = new window.PhotoSwipeLightbox({
        gallery: '.photoswipe-wrapper',
        children: 'a.product__gallery-toggle',
        mainClass: 'pswp--product-media-gallery',
        loop: false,
        showHideAnimationType: 'zoom',
        initialZoomLevel: (zoom) => (DeviceDetector.isMobile() ? zoom.vFill : zoom.fit),
        secondaryZoomLevel: (zoom) => (DeviceDetector.isMobile() ? zoom.fit : 1),
        pswpModule: window.PhotoSwipe,
      });

      /* The theme keeps its own close/prev/next markup in hidden divs at the bottom of
         this snippet, so the lightbox uses the theme's icon set rather than PhotoSwipe's. */
      this.lightbox.addFilter('uiElement', (element, data) => {
        if (data.name === 'close' && closeIcon) element.innerHTML = closeIcon.innerHTML;
        else if (data.name === 'arrowPrev' && prevIcon) element.innerHTML = prevIcon.innerHTML;
        else if (data.name === 'arrowNext' && nextIcon) element.innerHTML = nextIcon.innerHTML;
        return element;
      });

      this.lightbox.addFilter('itemData', (itemData) => {
        if (itemData.type === 'html' && itemData.element) {
          return { html: itemData.element.dataset.pswpHtml };
        }
        return itemData;
      });

      this.lightbox.init();

      this.lightbox.on('beforeOpen', () => {
        document.body.classList.add('overflow-hidden');
      });

      this.lightbox.on('closingAnimationStart', () => {
        document.body.classList.remove('overflow-hidden');
      });
    }
  }

  if (!customElements.get('product-gallery-zoom')) {
    customElements.define('product-gallery-zoom', ProductGalleryZoom);
  }

  /* MOBILE SLIDE COUNTER — the "1 / 4" pinned opposite the zoom toggle.

     Reads the DOM rather than the Swiper instance. Swiper marks the current slide with
     .swiper-slide-active and product-variants.js hides filtered media with .hidden, so both
     the things this has to react to are class changes on the slides themselves — one
     observer covers them, with no dependency on the vendor's `instance` property existing
     yet (it is created on DOMContentLoaded, and again on every variant switch). */
  class ProductGalleryCounter extends HTMLElement {
    connectedCallback() {
      this.currentTarget = this.querySelector('[data-gallery-counter-current]');
      this.totalTarget = this.querySelector('[data-gallery-counter-total]');
      this.wrapper = this.closest('.main-product__media--slider-wrapper')?.querySelector(
        '.swiper--product-gallery .swiper-wrapper'
      );

      if (!this.wrapper || !this.currentTarget || !this.totalTarget) return;

      /* subtree, because the classes that matter live on the slides rather than on the
         wrapper. That also picks up class changes deeper inside a slide (the gallery
         opener's own .is-active, for one) — harmless, since the work is coalesced into a
         single frame and the update is a cheap read. */
      this.observer = new MutationObserver(this.onMutate);
      this.observer.observe(this.wrapper, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });

      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
    }

    /* One slide change flips the class on several slides at once. */
    onMutate = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    };

    update() {
      const slides = Array.from(this.wrapper.children).filter(
        (slide) => slide.classList.contains('swiper-slide') && !slide.classList.contains('hidden')
      );

      /* A variant can leave a single media to show, and "1 / 1" is noise. */
      this.toggleAttribute('hidden', slides.length < 2);
      if (slides.length < 2) return;

      /* Before Swiper starts, no slide is active yet — the first one is what is on screen. */
      const active = slides.findIndex((slide) => slide.classList.contains('swiper-slide-active'));

      this.currentTarget.textContent = active < 0 ? 1 : active + 1;
      this.totalTarget.textContent = slides.length;
    }
  }

  if (!customElements.get('product-gallery-counter')) {
    customElements.define('product-gallery-counter', ProductGalleryCounter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navigation-drawer"] && !Shopify.designMode) return;
  try {
    /* Third level of the mobile navigation drawer. The markup ships open, so this
     component only adds the ability to collapse a group — nothing here is needed for
     the menu to be usable. Groups are independent: collapsing one leaves the rest. */
  class MenuAccordion extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-accordion-toggle]');
      this.toggle?.addEventListener('click', this.onToggleClick);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggleClick);
    }

    onToggleClick = () => {
      const isOpen = this.classList.toggle('is-open');
      this.toggle?.setAttribute('aria-expanded', String(isOpen));
    };
  }

  if (!customElements.get('menu-accordion')) {
    customElements.define('menu-accordion', MenuAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const STORAGE_KEY = 'wishlist:handles';
    const THUMB_WIDTH = 128;

    const escapeHtml = (value) => {
      const chars = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
      return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => chars[char]);
    };

    const groupDigits = (value, decimals, thousands, decimal) => {
      const parts = value.toFixed(decimals).split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    };

    // Shopify money_format placeholders, built without literal braces so the
    // pattern is never mistaken for Liquid output inside this block.
    const MONEY_PLACEHOLDER = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}', 'g');

    // Prices follow the shop's own money format instead of a hardcoded currency.
    const formatMoney = (cents, format) => {
      const value = (Number(cents) || 0) / 100;

      if (!format) return groupDigits(value, 2, ',', '.');

      return format.replace(MONEY_PLACEHOLDER, (match, name) => {
        switch (name) {
          case 'amount_no_decimals':
            return groupDigits(value, 0, ',', '.');
          case 'amount_with_comma_separator':
            return groupDigits(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return groupDigits(value, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return groupDigits(value, 2, "'", '.');
          default:
            return groupDigits(value, 2, ',', '.');
        }
      });
    };

    const thumbUrl = (url) => (url ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + THUMB_WIDTH : '');

    /* ------------------------------------------------------------------------
       Single source of truth. localStorage is read and parsed exactly ONCE per
       page load: a collection page can hold dozens of cards, and none of them
       is allowed to touch storage on its own. Reflecting a change goes through
       a handle -> elements registry, so a click costs one Map lookup instead of
       a document-wide querySelectorAll.
       --------------------------------------------------------------------- */
    const store = {
      order: [],
      handles: new Set(),
      registry: new Map(),
      listeners: new Set(),

      read() {
        let raw = null;

        try {
          raw = window.localStorage.getItem(STORAGE_KEY);
        } catch (error) {
          // storage unavailable (private mode, blocked cookies) — stay in memory
        }

        let parsed = [];

        if (raw) {
          try {
            const value = JSON.parse(raw);
            if (Array.isArray(value)) parsed = value.filter((handle) => typeof handle === 'string' && handle);
          } catch (error) {
            // corrupt value — start clean rather than throwing on every page
          }
        }

        this.order = parsed;
        this.handles = new Set(parsed);

        return this;
      },

      persist() {
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.order));
        } catch (error) {
          // ignore quota / private mode errors, the in-memory list still works
        }
      },

      has(handle) {
        return this.handles.has(handle);
      },

      get count() {
        return this.order.length;
      },

      toggle(handle) {
        if (this.handles.has(handle)) this.remove(handle);
        else this.add(handle);
      },

      add(handle) {
        if (!handle || this.handles.has(handle)) return;

        this.order.unshift(handle);
        this.handles.add(handle);
        this.commit(handle);
      },

      remove(handle) {
        if (!this.handles.delete(handle)) return;

        const index = this.order.indexOf(handle);
        if (index > -1) this.order.splice(index, 1);
        this.commit(handle);
      },

      commit(handle) {
        this.persist();
        this.reflect(handle);
        this.listeners.forEach((listener) => listener(this));
      },

      register(handle, element) {
        let group = this.registry.get(handle);

        if (!group) {
          group = new Set();
          this.registry.set(handle, group);
        }

        group.add(element);
      },

      unregister(handle, element) {
        const group = this.registry.get(handle);
        if (!group) return;

        group.delete(element);
        if (!group.size) this.registry.delete(handle);
      },

      reflect(handle) {
        const group = this.registry.get(handle);
        if (!group) return;

        const active = this.handles.has(handle);
        group.forEach((element) => element.reflect(active));
      },

      subscribe(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
      },
    }.read();

    // Another tab changed the list — re-sync without a page reload.
    window.addEventListener('storage', (event) => {
      if (event.key !== STORAGE_KEY) return;

      store.read();
      store.registry.forEach((group, handle) => store.reflect(handle));
      store.listeners.forEach((listener) => listener(store));
    });

    /* --- heart inside a product card ------------------------------------- */
    class WishlistToggle extends HTMLElement {
      connectedCallback() {
        this.handle = this.dataset.productHandle;
        if (!this.handle) return;

        this.button = this.querySelector('button');

        store.register(this.handle, this);
        this.reflect(store.has(this.handle));
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (!this.handle) return;

        this.removeEventListener('click', this.onClick);
        store.unregister(this.handle, this);
      }

      onClick = (event) => {
        event.preventDefault();
        store.toggle(this.handle);
      };

      reflect(active) {
        this.classList.toggle('active', active);
        if (this.button) this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    /* --- counter on the header trigger ----------------------------------- */
    class WishlistCount extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = store.subscribe(this.render);
        this.render();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      render = () => {
        const count = store.count;
        // empty string keeps the :empty rule in charge of hiding the badge
        this.textContent = count ? (count > 99 ? '+' : String(count)) : '';
      };
    }

    /* --- drawer ---------------------------------------------------------- */
    class WishlistDrawer extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-wishlist-trigger]');
        this.overlay = this.querySelector('[data-wishlist-overlay]');
        this.panel = this.querySelector('[data-wishlist-panel]');
        this.items = this.querySelector('[data-wishlist-items]');
        this.emptyMessage = this.querySelector('[data-wishlist-empty]');
        this.loader = this.querySelector('[data-wishlist-loader]');
        this.closeButton = this.querySelector('[data-wishlist-close]');

        // fetched products survive closing the drawer, so reopening costs nothing
        this.cache = new Map();
        this.isStale = true;
        this.renderToken = 0;

        this.mountLayer();

        if (this.trigger) this.trigger.addEventListener('click', this.onTriggerClick);
        if (this.overlay) this.overlay.addEventListener('click', this.close);
        if (this.closeButton) this.closeButton.addEventListener('click', this.close);
        // one delegated listener instead of one per row
        if (this.items) this.items.addEventListener('click', this.onItemsClick);

        this.unsubscribe = store.subscribe(this.onStoreChange);
      }

      disconnectedCallback() {
        if (this.trigger) this.trigger.removeEventListener('click', this.onTriggerClick);
        if (this.overlay) this.overlay.removeEventListener('click', this.close);
        if (this.closeButton) this.closeButton.removeEventListener('click', this.close);
        if (this.items) this.items.removeEventListener('click', this.onItemsClick);
        document.removeEventListener('keydown', this.onKeydown);

        if (this.unsubscribe) this.unsubscribe();
        this.unlockScroll();
        this.unmountLayer();
      }

      /* The trigger belongs in the header, the overlay and the panel do not.
         Both are position: fixed, and section-header.css promotes the header with
         transform: translateZ(0) while a nav dropdown is open — which makes
         .header the containing block for its fixed descendants. Left inside the
         header the closed panel, parked at translateX(100%), would then stick a
         full panel width past the right edge of the header and give the page a
         horizontal scrollbar for as long as the megamenu is open, and the overlay
         would only cover the header instead of the viewport. Moving both to <body>
         keeps them anchored to the viewport whatever the header does. */
      mountLayer() {
        if (this.isMounted || !this.panel) return;

        if (this.overlay) document.body.appendChild(this.overlay);
        document.body.appendChild(this.panel);
        this.isMounted = true;
      }

      /* The theme editor removes and re-inserts the header section, so the moved
         nodes have to go with it — otherwise every reload leaves another panel
         behind in <body>. */
      unmountLayer() {
        if (!this.isMounted) return;

        if (this.overlay) this.overlay.remove();
        if (this.panel) this.panel.remove();
        this.isMounted = false;
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      onTriggerClick = () => {
        if (this.isOpen) this.close();
        else this.open();
      };

      open = () => {
        this.classList.add('is-open');
        if (this.overlay) this.overlay.classList.add('is-open');
        if (this.panel) this.panel.classList.add('is-open');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');

        document.addEventListener('keydown', this.onKeydown);
        this.lockScroll();

        if (this.panel) this.panel.focus({ preventScroll: true });
        if (this.isStale) this.render();
      };

      close = () => {
        if (!this.isOpen) return;

        this.classList.remove('is-open');
        if (this.overlay) this.overlay.classList.remove('is-open');
        if (this.panel) this.panel.classList.remove('is-open');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');

        document.removeEventListener('keydown', this.onKeydown);
        this.unlockScroll();

        if (this.trigger) this.trigger.focus({ preventScroll: true });
      };

      onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };

      lockScroll() {
        if (this.panel && window.bodyScrollLock) window.bodyScrollLock.disableBodyScroll(this.panel);
      }

      unlockScroll() {
        if (this.panel && window.bodyScrollLock) window.bodyScrollLock.enableBodyScroll(this.panel);
      }

      onStoreChange = () => {
        this.isStale = true;
        if (this.isOpen) this.render();
      };

      onItemsClick = (event) => {
        const button = event.target.closest('[data-wishlist-remove]');
        if (!button) return;

        event.preventDefault();
        store.remove(button.dataset.wishlistRemove);
      };

      async render() {
        if (!this.items) return;

        this.isStale = false;

        const handles = store.order.slice();

        if (!handles.length) {
          this.items.replaceChildren();
          this.toggleLoader(false);
          this.toggleEmptyMessage(true);
          return;
        }

        // A render started later must win — an item can be removed, or another
        // tab can change the list, while a fetch is still in flight.
        const token = ++this.renderToken;

        // Only spin when something actually has to be fetched: reopening the
        // drawer is served from the cache and must not flash a loader.
        if (handles.some((handle) => !this.cache.has(handle))) {
          this.toggleEmptyMessage(false);
          this.toggleLoader(true);
        }

        try {
          await this.hydrate(handles);
        } finally {
          if (token === this.renderToken) this.toggleLoader(false);
        }

        if (token !== this.renderToken) return;

        const fragment = document.createDocumentFragment();
        let rendered = 0;

        handles.forEach((handle) => {
          const product = this.cache.get(handle);
          if (!product) return;

          fragment.appendChild(this.buildItem(handle, product));
          rendered += 1;
        });

        this.items.replaceChildren(fragment);
        this.toggleEmptyMessage(rendered === 0);
      }

      // Fetches only what is not cached yet. allSettled, not all: a product that
      // has been unpublished or deleted must not take the whole list down.
      async hydrate(handles) {
        const missing = handles.filter((handle) => !this.cache.has(handle));
        if (!missing.length) return;

        const root = (this.dataset.rootUrl || '/').replace(/\/$/, '');

        const results = await Promise.allSettled(
          missing.map((handle) =>
            fetch(root + '/products/' + encodeURIComponent(handle) + '.js').then((response) =>
              response.ok ? response.json() : Promise.reject(response.status)
            )
          )
        );

        results.forEach((result, index) => {
          this.cache.set(missing[index], result.status === 'fulfilled' ? result.value : null);
        });
      }

      buildItem(handle, product) {
        const item = document.createElement('li');
        const image = product.featured_image || (product.images && product.images[0]);
        const url = escapeHtml(product.url);

        item.className = 'wishlist__item';

        item.innerHTML =
          '<a class="wishlist__item-media" href="' +
          url +
          '" tabindex="-1" aria-hidden="true">' +
          (image
            ? '<img src="' + escapeHtml(thumbUrl(image)) + '" alt="" width="64" height="64" loading="lazy">'
            : '') +
          '</a>' +
          '<div class="wishlist__item-info">' +
          '<a class="wishlist__item-title text-link" href="' +
          url +
          '"><span class="text-link--on-hover">' +
          escapeHtml(product.title) +
          '</span></a>' +
          '<span class="wishlist__item-price">' +
          escapeHtml(formatMoney(product.price, this.dataset.moneyFormat)) +
          '</span>' +
          '</div>' +
          '<button type="button" class="button-reset wishlist__remove text-link" data-wishlist-remove="' +
          escapeHtml(handle) +
          '"><span class="text-link--on-hover">' +
          escapeHtml(this.dataset.removeText) +
          '</span></button>';

        return item;
      }

      toggleEmptyMessage(show) {
        if (this.emptyMessage) this.emptyMessage.hidden = !show;
      }

      toggleLoader(show) {
        if (this.loader) this.loader.hidden = !show;
      }
    }

    if (!customElements.get('wishlist-toggle')) customElements.define('wishlist-toggle', WishlistToggle);
    if (!customElements.get('wishlist-count')) customElements.define('wishlist-count', WishlistCount);
    if (!customElements.get('wishlist-drawer')) customElements.define('wishlist-drawer', WishlistDrawer);
  })();
  } catch(e) { console.error(e); }
})();

})();
